import { useQuery } from '@tanstack/react-query';
import { API } from '@src/api/index.ts';
import { EntityByIdParam } from '@src/api/types.ts';

export const useExerciseQuery = (params: EntityByIdParam) => {
  return useQuery({
    queryKey: ['exercise', params.id],
    queryFn: async () => await API.exercises.getById(params),
    enabled: typeof params?.id !== 'undefined',
  });
};
